export class PaymentRetrieval {
    static PaymentMethod = {
        SWISH: 'swish',
        STRIPE: 'stripe',
        COUPON: 'coupon'
    }
}
